export const hasOneItem = <T>(array: ArrayLike<T>): boolean => array.length === 1
